/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-console */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'

import { MathUtils } from 'three'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

import { useViewerContext } from '../context/ViewerProvider'

export function Model() {
  const [gltf, setGltf] = useState(null)
  const [, viewerDispatch] = useViewerContext()

  useEffect(() => {
    if (gltf) return

    const loader = new GLTFLoader()

    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.7/')
    dracoLoader.setDecoderConfig({ type: 'js' })

    loader.setDRACOLoader(dracoLoader)

    loader.load(
      'https://files.cgtrader.com/Kitsune.glb',
      (gltf) => {
        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            child.geometry.computeBoundingBox()
            child.geometry.computeBoundingSphere()
            child.geometry.computeVertexNormals()

            child.material.metalness = 0.3
            child.material.roughness = 0.8
          }
        })
        setGltf(gltf)
        viewerDispatch({ type: 'loaded', payload: true })
      },
      undefined,
      (error) => {
        console.error(error)
      }
    )

    return () => {
      if (gltf) {
        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            child.geometry.dispose()
            if (child.material) {
              if (Array.isArray(child.material)) {
                child.material.forEach((material) => {
                  material.dispose()
                })
              } else {
                child.material.dispose()
              }
            }
          }
        })
        setGltf(null)
      }
    }
  }, [gltf, viewerDispatch])

  return (
    <group name="Model" scale={[0.1, 0.1, 0.1]} rotation={[0, MathUtils.DEG2RAD * (90 + 45), 0]}>
      {gltf ? <primitive object={gltf.scene} /> : null}
    </group>
  )
}
